import { ComponentConfig } from "@measured/puck";
import WysiwygField from "../../Fields/WysiwygField";
import TextBlockRender from "./TextBlockRender";

const TextBlock: ComponentConfig<{ text: string }> = {
    fields: {
        // @ts-ignore
        text: {
            // @ts-ignore
            ...WysiwygField.fields.editor,
            label: 'Tekst'
        },
    },
    render: (props) => (
        <TextBlockRender {...props} />
    ),
}

export default TextBlock;
